/* eslint-disable react/no-children-prop */
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

interface MarkdownProps {
  content?: string;
  styleClass?: string;
  className?: string;
}

const Markdown: React.FC<MarkdownProps> = ({ content = '', styleClass, className }) => (
  <div className={`${className} ${styleClass}`}>
    <ReactMarkdown rehypePlugins={[rehypeRaw, remarkGfm]} children={content} />
  </div>
);

export default Markdown;
